import type { UserInterface } from 'shared/types/user-interface'

export const getAvatarUrl = (dashboardUser?: UserInterface): string | undefined =>
  dashboardUser && dashboardUser.subaccountsAvatarUrls[dashboardUser.id]
